export default {"src":"/_next/static/media/Infectionsandabscesses.73d05d6c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};